"use client";

import { useStore, type Node } from "@xyflow/react";

/**
 * Returns true when 2+ nodes are selected on the canvas.
 *
 * Reads directly from React Flow's internal Zustand store so the value
 * is available in the **same render cycle** that `node.selected` flips.
 * This avoids the 1-frame flash that occurs when syncing through a
 * separate React context (BoxSelectionHandler → NodeHoverContext).
 *
 * Use this in node components to suppress per-node toolbars during
 * multi-selection.  Must be called inside `<ReactFlow>`.
 */
export function useMultipleNodesSelected() {
  return useStore(selectedCountSelector) >= 2;
}
const selectedCountSelector = (state: {
  nodes: Node[];
}) => {
  let count = 0;
  for (const n of state.nodes) {
    if (n.selected) count++;
  }
  return count;
};